import { render, staticRenderFns } from "./home_secondary_edit.vue?vue&type=template&id=25a06736&"
import script from "./home_secondary_edit.vue?vue&type=script&lang=js&"
export * from "./home_secondary_edit.vue?vue&type=script&lang=js&"
import style0 from "./home_secondary_edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports